import UnauthorizedPage from "../../../Pages/UnauthorizedPage/UnauthorizedPage";
import { RootState } from "../../../Redux/store";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";
import React from "react";

interface PrivateRouteProps {
  children: React.ReactNode;
  isAdmin?: boolean;
  isDoorAdmin?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  isAdmin = false,
  isDoorAdmin = false,
}) => {
  const { token, user, admin, adminToken } = useSelector(
    (state: RootState) => state.auth,
  );
  const isAuthenticated = token && user;
  const isAdminAuthenticated = admin && adminToken;
  const isDoorAdminRole = admin?.role === "DoorLogAdmin";

  if (isAdmin && !isAdminAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!isAuthenticated && !isAdmin) {
    return <Navigate to="/login" replace />;
  }
  if (isDoorAdminRole && isDoorAdmin) {
    return <>{children}</>;
  }
  if (isDoorAdminRole && !isDoorAdmin) {
    return <UnauthorizedPage />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
